import React from "react";
import type { KioskLanguage } from "../types";

interface LanguagePickerProps {
  languages: KioskLanguage[];
  languageCode: string;
  onSelectLanguage: (code: string) => void;
  className?: string;
}

/**
 * The one language control, used on the wizard, the Done screen and the lookup screen so a
 * resident is never stranded without it (AB#9884).
 *
 * translate="no" keeps Google Translate from rendering "Espanol" as "Spanish" once the page
 * is already translated — a language must always be offered in its own name.
 */
export const LanguagePicker: React.FC<LanguagePickerProps> = ({
  languages,
  languageCode,
  onSelectLanguage,
  className
}) => {
  if (languages.length <= 1) return null;

  return (
    <div
      className={`lang notranslate ${className ?? ""}`.trim()}
      translate="no"
      role="group"
      aria-label="Choose your language"
    >
      {languages.map((language) => {
        const selected = languageCode === language.code;

        return (
          <button
            key={language.code}
            type="button"
            className={selected ? "on" : ""}
            onClick={() => onSelectLanguage(language.code)}
            aria-pressed={selected}
            lang={language.code}
          >
            {language.autoglossonym || language.name || language.code}
          </button>
        );
      })}
    </div>
  );
};
